import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { MedicalAppointmentValidation } from "src/app/model/medical-appointment-validation";
import { MedicalAppointmentValidationProcedure } from "src/app/model/medical-appointment-validation-procedure";

@Component({
  selector: "app-integrated-admission-appointment-validation-dialog",
  templateUrl:
    "./integrated-admission-appointment-validation-dialog.component.html",
  styleUrls: [
    "./integrated-admission-appointment-validation-dialog.component.css",
  ],
})
export class IntegratedAdmissionAppointmentValidationDialogComponent
  implements OnInit
{
  isNoOk: boolean = false;
  displayMessage: string = "";
  procedures: MedicalAppointmentValidationProcedure[] = [];
  authorizationNumber: string = "";
  isPreadmission: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<IntegratedAdmissionAppointmentValidationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.procedures = this.data.procedures || [];
    this.isPreadmission = this.data.isPreadmission || false;

    if (this.data && this.data.validation) {
      // MODO LECTURA
      this.displayMessage = this.data.validation.DisplayMessage;
      this.isNoOk =
        this.data.validation.NoValidate &&
        !this.data.validation.PartialValidate;
      this.authorizationNumber = this.data.validation.AuthorizationNumber;
    } else {
      // MODO EDICIÓN
      this.isNoOk = false;
      this.displayMessage = "";

      if (this.data && this.data.authorizationNumber) {
        this.authorizationNumber = this.data.authorizationNumber;
      } else {
        this.authorizationNumber = "";
      }

      this.procedures.forEach((p) => {
        p.IsOk = true;

        if (this.data.previewsProcedures) {
          const previewProcedure = this.data.previewsProcedures.find(
            (pp) => pp.AgreementPriceId === p.AgreementPriceId
          );
          if (previewProcedure) {
            p.IsOk = previewProcedure.IsOk;
          }
        }
      });
    }
  }

  get proceduresWithAmount(): MedicalAppointmentValidationProcedure[] {
    if (!this.procedures) {
      return [];
    }
    return this.procedures.filter((p) => p.Amount > 0);
  }

  get proceduresWithNoAmount(): MedicalAppointmentValidationProcedure[] {
    if (!this.procedures) {
      return [];
    }
    return this.procedures.filter((p) => p.Amount === 0);
  }

  onNoOkClick(): void {
    if (this.data.validation) {
      this.dialogRef.close();
    } else {
      let noOk = false;
      this.proceduresWithAmount.forEach((p) => {
        if (!p.IsOk) {
          noOk = true;

          if (!p.AppliedRulesIds) {
            p.AppliedRulesIds = [];
          }

          if (p.AppliedRulesIds.length !== 0) {
            noOk = true;
          }

          if (p.AppliedRulesIds.length === 0) {
            p.AppliedRulesIds.push(1);
          }
        }
      });

      this.proceduresWithNoAmount.forEach((p) => {
        if (p.AppliedRulesIds && p.AppliedRulesIds.length > 0) {
          p.IsOk = !noOk;
          p.AppliedRulesIds = noOk ? [1] : [];
        }
      });

      this.dialogRef.close({
        authorizationNumber: this.authorizationNumber,
        procedures: this.procedures.filter((p) => !p.IsOk),
      });
    }
  }
}
